import { use, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { userContextAction } from "../store/UserContext";
import useApi from "../function/useApi";
import { Flex, Link, Text,Status, VStack,Table, useBreakpointValue, Button,Checkbox,
  CloseButton, Dialog, Portal} from "@chakra-ui/react";
import { FaArrowLeft } from "react-icons/fa";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { FaCamera } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
function parseCoordinate(coordString) {
    let lat = "123";
    let lng = "123";
    if(!coordString) {
        return { lat, lng };
    };
  const parts = coordString.trim().split(" ");
  
  
  
  lat = parseFloat(parts[1]);
  lng = parseFloat(parts[3]);

  if (parts[0] === "S") lat = -lat;
  if (parts[2] === "W") lng = -lng;

  return { lat, lng };
}
const UnitDetail = ()=>{
    const { id } = useParams();
    const user = useSelector(u=>u.userContext.user);
    const { responses, loading, error, fetchData } = useApi();
    const [unit, setUnit] = useState({});
    const dispatch = useDispatch();
    const [statusColor, setStatusColor] = useState('grey'); 
    const [openDialog, setOpenDialog] = useState(false);

    const coordinate = parseCoordinate(unit.location);
    const mapUrl = `https://www.google.com/maps?q=${coordinate.lat},${coordinate.lng}&z=14&output=embed`;
    const widthVariant = useBreakpointValue({ base: "100%", xl: "40%" });

    useEffect(()=>{
        fetchData('unit',`${process.env.REACT_APP_API_URL}?data=machine&id=${id}`)
    },[])
    const handleOpenDialog = () => {
      setOpenDialog(true);
    }
    useEffect(()=>{
        if(responses?.unit){
            setUnit(responses.unit);
        }
    },[responses?.unit]);


    useEffect(()=>{
        if(loading?.unit){
            dispatch(userContextAction.loadingOn())
        }else{
            dispatch(userContextAction.loadingOff())
        }
    },[loading?.unit]);

    useEffect(()=>{
        if(unit){
            switch(unit.status){
                case "YELLOW": setStatusColor('yellow'); break;
                case "GREEN": setStatusColor('green'); break;
                case "RED" : setStatusColor('blue');break;
                default: setStatusColor('grey'); break;
            }
        }
    },[unit]);
    
    return(
        <Flex padding={'10vh 10vw'} width={'fit-content'} height={"100%"}  justifyContent={'center'} flexDir={'column'} gap="10px" alignSelf={{base:'flex-start', xl:'center'}}>
            <Link  textStyle="3xl" fontWeight={'bold'} href="/home/unit"><FaArrowLeft /> Unit</Link>
            <br></br>
            
                <VStack  width={'fit-content'} height={"100%"} flexDir={'column'} gap={'20px'} alignItems={'center'} alignSelf={'center'}>
                            <iframe title="google-map" width={widthVariant} height={'60%'} style={{ border: 0 }} src={mapUrl} allowFullScreen loading="lazy" ></iframe>
                            <Text textStyle={'2xl'}>{unit.local_name}</Text>
                            <Text>{unit.rent}</Text>
                            <Text>Total HM: {unit.total_hour}</Text>
                            <HMUnitTable machineId={id}/>    
                            <CycleUnitTable machineId={id} user={user} handleOpenDialog={handleOpenDialog}/>    
                </VStack>
                
     
        </Flex>

    )
}

export default UnitDetail;


const HMUnitTable = ({machineId}) =>{
    const { responses, loading, error, fetchData } = useApi();
    const [items, setItems] = useState([]);
    const widthVariant = useBreakpointValue({ base: "100%", xl: "600px" });

    const dispatch = useDispatch();
    useEffect(()=>{
        const fromDay = getLastDay(Number(7));
        const today = getLastDay(Number(0));
        fetchData('dailyHm',`${process.env.REACT_APP_API_URL}?data=hour&id=${machineId}&startDate=${fromDay}&endDate=${today}`)

    },[]);
    useEffect(()=>{
        if(responses?.dailyHm){
            setItems(responses.dailyHm);
        }
    },[responses?.dailyHm]);

    useEffect(()=>{
        if(loading?.unit){
            dispatch(userContextAction.loadingOn())
        }else{
            dispatch(userContextAction.loadingOff())
        }
    },[loading?.dailyHm]);
    return (
    <Table.Root size="sm" width={widthVariant}>
        <Table.Caption captionSide="top">
        HM dalam 7 hari terakhir
      </Table.Caption>
      <Table.Header>
        <Table.Row>
            <Table.ColumnHeader>Unit</Table.ColumnHeader>
          <Table.ColumnHeader>Tanggal</Table.ColumnHeader>
          <Table.ColumnHeader>Engine On</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        
        {items.map((item, index) => (
          <Table.Row key={index}>
            <Table.Cell>{item.name}</Table.Cell>
            <Table.Cell>{item.dateOn}</Table.Cell>
            <Table.Cell textAlign="end">{item.engineOn ? item.engineOn : 0} Jam</Table.Cell>
          </Table.Row>
        ))} 
      </Table.Body>
    </Table.Root>
  )
    
}

const CycleUnitTable = ({machineId, user}) =>{
    const { responses, loading, error, fetchData } = useApi();
    const [items, setItems] = useState([]);
    const widthVariant = useBreakpointValue({ base: "100%", xl: "800px" });
      const [date, setDate] = useState(new Date());

    const dispatch = useDispatch();
    useEffect(()=>{
        fetchData('cycle',`${process.env.REACT_APP_API_URL}?data=cycle&machineId=${machineId}`)

    },[]);
    useEffect(()=>{
        if(responses?.cycle){
            setItems(responses.cycle.sort((a, b) => a.num - b.num));
        }
    },[responses?.cycle]);

    useEffect(()=>{
        if(loading?.cycle){
            dispatch(userContextAction.loadingOn())
        }else{
            dispatch(userContextAction.loadingOff())
        }
    },[loading?.dailyHm]);


    const handlePaidAtChange = async (checked, item) => {
        if(checked){
            
           fetchData('paidAt',`${process.env.REACT_APP_API_URL}?data=cycle&paidAt=${currDate()}&id=${item.id}`,'PUT')
        }        
    }

    useEffect(()=>{
        if(responses?.paidAt){
            fetchData('cycle',`${process.env.REACT_APP_API_URL}?data=cycle&machineId=${machineId}`)
        }
    },[responses?.paidAt]);
    return (
    <Table.Root size="sm" width={widthVariant} marginTop={'20px'}>
        <Table.Caption captionSide="top">
        History Pembayaran
      </Table.Caption>
      <Table.Header>
        <Table.Row>
            <Table.ColumnHeader>Tagihan</Table.ColumnHeader>
            <Table.ColumnHeader width={'120px'}>HM Dibayar</Table.ColumnHeader>
            <Table.ColumnHeader width={'90px'}>Start HM</Table.ColumnHeader>
            <Table.ColumnHeader width={'90px'}>End HM</Table.ColumnHeader>
            <Table.ColumnHeader width={'130px'}>Total Biaya</Table.ColumnHeader>
            <Table.ColumnHeader>Status</Table.ColumnHeader>
            <Table.ColumnHeader width={'130px'}>Selesai Tanggal</Table.ColumnHeader>
            {user?.company === 'ptc' ? <Table.ColumnHeader>Pembayaran Diterima</Table.ColumnHeader> : <Table.ColumnHeader>Pembayaran Lunas</Table.ColumnHeader>}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        
        {items.map((item, index) => (
          <Table.Row key={item.id}>
            <Table.Cell>{item.num}</Table.Cell>
            <Table.Cell>{item.hm_cycle}</Table.Cell>
            <Table.Cell>{item.hm_from}</Table.Cell>
            <Table.Cell>{item.hm_to}</Table.Cell>
            <Table.Cell>{`Rp. ${Number(item.total_cost).toLocaleString('id-ID')}`}</Table.Cell>
            <Table.Cell>{item.status == '1' ? 'Selesai' : 'Masih Berjalan'}</Table.Cell>
            <Table.Cell>{item.dueAt === 'empty' ? '' : item.dueAt}</Table.Cell>
            <Table.Cell>
                {user?.company === 'ptc' ? 
                    item.paidAt !== undefined ? 
                                (<Checkbox.Root variant={'solid'} checked={true} disabled={true} colorPalette={'blue'}>
                            <Checkbox.HiddenInput />
                            <Checkbox.Control />
                            <Checkbox.Label>{item.paidAt}</Checkbox.Label>
                            </Checkbox.Root>)
                            :
                            (<Checkbox.Root variant={'solid'} checked={false}   colorPalette={'blue'} onCheckedChange={(e) => handlePaidAtChange(e.checked, item)}>
                            <Checkbox.HiddenInput />
                            <Checkbox.Control />
                            <Checkbox.Label>Tandakan Lunas</Checkbox.Label>
                            </Checkbox.Root>):

                (<Checkbox.Root checked={item.paidAt == null} disabled={true} variant={'solid'} colorPalette={'blue'}>
                  <Checkbox.HiddenInput />
                  <Checkbox.Control />
                  <Checkbox.Label>{item.paidAt?item.paidAt:'Belum Lunas'}</Checkbox.Label>
                </Checkbox.Root>)}
            </Table.Cell>
          </Table.Row>
        ))} 
      </Table.Body>
    </Table.Root>
  )
    
}

function getLastDay(num){
    const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - num);
  
  const dd = String(yesterday.getDate()).padStart(2, '0');
  const mm = String(yesterday.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const yyyy = yesterday.getFullYear();
  
//   const normal = `${dd}/${mm}/${yyyy}`;
  const dbFormat = `${yyyy}-${mm}-${dd}`;
  return dbFormat
  }

function currDate(){
const now = new Date();
const formatted = now.toLocaleDateString("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
});

  return formatted
  }